// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "rescript-classnames/src/Cn.bs.js";
import * as Util from "../../../common/util.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Regex from "../../../utils/Regex.bs.js";
import * as React from "react";
import * as Button from "../../library/Button.bs.js";
import Link from "next/link";
import * as InputField from "../../forms/InputField.bs.js";
import * as Js_promise from "@rescript/std/lib/es6/js_promise.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as FormHelpers from "../../../utils/FormHelpers.bs.js";
import * as $$Notification from "../../library/Notification.bs.js";
import * as ReactHookForm from "../../../bindings/ReactHookForm.bs.js";
import * as OnboardingLayout from "../../../layouts/OnboardingLayout.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as PrezzeeSecureClient from "../../../api/PrezzeeSecureClient.bs.js";
import * as ResetPasswordOnboardingStyles from "./ResetPasswordOnboardingStyles.bs.js";
import * as OnboardingLayoutCreateAccountButton from "../../library/OnboardingLayoutCreateAccountButton.bs.js";

var emailInput = {
  required: {
    value: true,
    message: "Your email is required"
  },
  pattern: {
    value: Regex.emailRegex,
    message: "Please enter a valid email address"
  }
};

function ResetPasswordOnboarding(props) {
  var match = React.useState(function () {
        return false;
      });
  var setIsNotificationVisible = match[1];
  var match$1 = React.useState(function () {
        return false;
      });
  var setButtonPressed = match$1[1];
  var buttonPressed = match$1[0];
  var form = ReactHookForm.useForm({
        mode: "onTouched"
      }, undefined);
  var onSubmit = React.useCallback((function (data) {
          Curry._1(setButtonPressed, (function (param) {
                  return true;
                }));
          setTimeout((function (param) {
                  Curry._1(setIsNotificationVisible, (function (param) {
                          return false;
                        }));
                  Curry._1(setButtonPressed, (function (param) {
                          return false;
                        }));
                }), 30000);
          Js_promise.then_((function (param) {
                  return Promise.resolve(Curry._1(setIsNotificationVisible, (function (param) {
                                    return true;
                                  })));
                }), PrezzeeSecureClient.resetPassword(data.email));
          Curry._1(form.reset, undefined);
        }), [form]);
  return JsxRuntime.jsxs(OnboardingLayout.make, {
              children: [
                JsxRuntime.jsx(OnboardingLayoutCreateAccountButton.make, {}),
                JsxRuntime.jsx("div", {
                      children: match[0] ? JsxRuntime.jsx($$Notification.make, {
                              notificationType: /* NotificationSuccess */2,
                              title: "Request successful",
                              description: "Please check your email for password reset instructions"
                            }) : null,
                      className: ResetPasswordOnboardingStyles.notificationContainer
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("h1", {
                              children: Util.ReactStuff.s(props.title),
                              className: ResetPasswordOnboardingStyles.titleStyle
                            }),
                        JsxRuntime.jsx("h2", {
                              children: Util.ReactStuff.s("Enter your email below"),
                              className: ResetPasswordOnboardingStyles.subtitleStyle
                            }),
                        JsxRuntime.jsxs("form", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(Link, {
                                            href: "/forgot-email-address",
                                            prefetch: false,
                                            children: JsxRuntime.jsx("a", {
                                                  children: Util.ReactStuff.s("Forgot your email?"),
                                                  className: "text-light-gray text-xs"
                                                })
                                          }),
                                      className: "block text-right"
                                    }),
                                JsxRuntime.jsx(InputField.make, {
                                      type_: "email",
                                      name: "email",
                                      placeholder: "Email",
                                      disabled: form.formState.isSubmitting,
                                      inputRef: Caml_option.some(Curry._1(form.register, emailInput)),
                                      error: FormHelpers.getFieldError(form.errors, "email")
                                    }),
                                JsxRuntime.jsx("button", {
                                      children: Util.ReactStuff.s(form.formState.isSubmitting ? "Submitting..." : "Reset my password"),
                                      className: Cn.make([
                                            ResetPasswordOnboardingStyles.submitBtn,
                                            buttonPressed ? Button.disabled : Button.primaryStyle
                                          ]),
                                      disabled: buttonPressed
                                    })
                              ],
                              onSubmit: Curry._2(form.handleSubmit, onSubmit, FormHelpers.onError)
                            })
                      ],
                      className: ResetPasswordOnboardingStyles.mainContainer
                    })
              ],
              onboardingKind: /* ShowAppDownload */1
            });
}

var Link$1;

var initialInput = {
  email: ""
};

var make = ResetPasswordOnboarding;

var $$default = ResetPasswordOnboarding;

export {
  Link$1 as Link,
  emailInput ,
  initialInput ,
  make ,
  $$default ,
  $$default as default,
}
/* Util Not a pure module */
